// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"d43f4268","271":"13efd700","308":"67d920f0","468":"48a42fcb","586":"f91f2ebc","665":"360f4763"}[chunkId] + ".chunk.js";
};